import {
  LinkCardParamsSchema,
  defaultLinkCardParams,
  type LinkCardParams,
} from "@playbookai/widget-schemas";
import type { YjsWidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { paramsFromYMap, paramsToYMap } from "../yjs-params.js";
import { LinkCardWidget } from "./Component.js";

/** `href` is char-merged alongside `label` per PB-418's field list. */
const TEXT_FIELDS = ["label", "href"] as const;

export const linkCardDef: YjsWidgetDef<LinkCardParams> = {
  kind: "linkCard",
  label: "Link card",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 300, h: 150 },
  defaultParams: defaultLinkCardParams,
  Component: LinkCardWidget,
  storage: "yjs",
  accent: "purple",
  textFields: TEXT_FIELDS,
  paramsFromY: (raw) =>
    paramsFromYMap(raw, LinkCardParamsSchema, defaultLinkCardParams),
  paramsToY: (next) =>
    paramsToYMap(next as Record<string, unknown>, TEXT_FIELDS),
};

registerWidget(linkCardDef);
